"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterplanetaryCinematicsRebalanced = void 0;
var Card_1 = require("../../Card");
var Tags_1 = require("../../Tags");
var CardType_1 = require("../../CardType");
var CardName_1 = require("../../../CardName");
var CardRenderer_1 = require("../../render/CardRenderer");
var InterplanetaryCinematicsRebalanced = (function (_super) {
    __extends(InterplanetaryCinematicsRebalanced, _super);
    function InterplanetaryCinematicsRebalanced() {
        return _super.call(this, {
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.INTERPLANETARY_CINEMATICS_REBALANCED,
            tags: [Tags_1.Tags.BUILDING],
            startingMegaCredits: 40,
            metadata: {
                cardNumber: 'R19',
                description: 'You start with 40 M€ and 12 steel.',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.br.br.br;
                    b.megacredits(40).nbsp.steel(12).digit;
                    b.corpBox('effect', function (ce) {
                        ce.effect('Each time you play an event, you gain 3 M€.', function (eb) {
                            eb.event().played.startEffect.megacredits(3);
                        });
                    });
                }),
            },
        }) || this;
    }
    InterplanetaryCinematicsRebalanced.prototype.onCardPlayed = function (player, card) {
        if (player.corporationCard !== undefined && player.corporationCard.name === this.name && card.cardType === CardType_1.CardType.EVENT) {
            player.megaCredits += 3;
        }
    };
    InterplanetaryCinematicsRebalanced.prototype.play = function (player) {
        player.steel = 12;
        return undefined;
    };
    return InterplanetaryCinematicsRebalanced;
}(Card_1.Card));
exports.InterplanetaryCinematicsRebalanced = InterplanetaryCinematicsRebalanced;
//# sourceMappingURL=InterplanetaryCinematicsRebalanced.js.map